<template>
  <div class="nav-contaienr">
    <div class="nav-box">
      <div class="icon-box">
        <img :src="logoUrl" alt="">
        <span>{{ title }}</span>
      </div>
      <div class="menu-button" @click="handleMenu">
        <hamburger-button v-show="!isMenuOpen" theme="outline" size="24" fill="#333" />
        <Close v-show="isMenuOpen" theme="outline" size="24" fill="#333" />
      </div>
    </div>
    <ul class="menu-list" v-show="isMenuOpen">
      <li class="menu-item" v-for="(item, index) in menuList" :key="index" @click="handleClick(item.to_link)"><a
          :href="item.id"></a> {{ item.name }}</li>
    </ul>
  </div>
</template>

<script>
import { HamburgerButton, Close } from '@icon-park/vue'
export default {
  components: {
    HamburgerButton,
    Close
  },
  data () {
    return {
      logoUrl: require('@/assets/imgs/logo.png'),
      title: '华艺元界',
      menuList: [
        { id: '#artshare', name: '艺术传播', to_link: 'scroll-to-artshare' },
        { id: '#news', name: '艺术资讯', to_link: 'scroll-to-news' },
        { id: '#room', name: '线上展馆', to_link: 'scroll-to-room' },
        { id: '#artist', name: '入驻', to_link: 'scroll-to-artist' },
        { id: '#app', name: 'app下载', to_link: 'scroll-to-app' },
        { id: '#dataview', name: '华艺数资', to_link: 'scroll-to-dataview' },
        { id: '#about', name: '关于我们', to_link: 'scroll-to-about' }

      ],
      isMenuOpen: false // 菜单是否打开
    }
  },
  methods: {
    handleMenu () {
      this.isMenuOpen = !this.isMenuOpen // 切换菜单状态
    },
    handleClick (link) {
      this.isMenuOpen = false // 点击菜单项时关闭菜单
      this.$emit('scroll-to-news', link)
      // console.log(link)
    }
  }
}
</script>
<style lang="less">
.nav-contaienr {
  width: 100%;
  height: inherit;
  background-color: transparent;

  background-color: rgba(#EFF1FD, .9);
  backdrop-filter: blur(5px);
  box-sizing: border-box;

  .nav-box {
    display: flex;
    align-items: center;
    height: inherit;
    justify-content: space-between;
    overflow: hidden;
    padding: 0 16px;

    .icon-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
      }

      span {
        font-size: 20px;
        line-height: inherit;
        text-indent: 1rem;
        font-weight: 500;
      }
    }

    .menu-button {
      width: 20px;
      height: 20px;
    }

  }

  .menu-list {
    width: 100%;
    height: auto;
    background-color: rgba(#EFF1FD, .9);
    padding: 15px 0;
    box-sizing: border-box;

    li {
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding: 0 16px;
    }
  }

}
</style>